'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      // spacingBottom: 50,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {text: '1日のデマンド実績'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      rotation: -45
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        let point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
        if (scope.isMissingTime(point.x)) {
          tip_format += "データ無し";
        } else {
          tip_format += point.y + " kW";
        }
        tip_format += "</span>"

        return tip_format;
      }
    },
    series: [
      {
        name: '実績',
        color: '#1F85CF',
        marker: {symbol: 'circle'},
        lineWidth: 4
      },
      {
        name: '目標電力',
        type: 'line',
        color: '#8bc34a',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        }
      },
      {
        name: '限界電力',
        type: 'line',
        color: '#e67e22',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        }
      },
      {
        name: '契約電力',
        type: 'line',
        color: '#D32F2F',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        }
      }
    ]
  };

  return chartConfig;
};



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/daily/daily_demand_report.config.js